import { Button, Flex, Header, Modal, TextContent } from 'components';

export type AuthError =
  | 'invalid_data'
  | 'already_exists'
  | 'code_not_found'
  | 'user_not_found'
  | 'session_not_found'
  | 'unexpected';

interface IProps {
  onClose: () => void;
  error: AuthError;
}

function ModalError(props: IProps) {
  return (
    <Modal
      header='Ошибка авторизации'
      onClose={props.onClose}
      size={400}
    >
      <Flex
        direction='column'
        gap={20}
      >
        <TextContent align='center'>{getErrorText(props.error)}</TextContent>
        <Button onClick={props.onClose}>Закрыть</Button>
      </Flex>
    </Modal>
  );
}

function getErrorText(input: AuthError): string {
  if (input === 'invalid_data') {
    return 'Данные введены неверно, проверьте корректность ввода';
  }

  if (input === 'already_exists') {
    return 'Аккаунт с этими данными уже существует';
  }

  if (input === 'code_not_found') {
    return 'Код подтверждения неверен, попробуй ещё раз';
  }

  if (input === 'user_not_found') {
    return 'Пользователь с такими данными не найден, проверьте ввод данных или зарегистрируйтесь';
  }

  if (input === 'session_not_found') {
    return 'Сессия авторизации просрочена, обновите страницу и попробуйте авторизоваться ещё раз';
  }

  return 'Неожиданная ошибка, повторите попытку позже';
}

export default ModalError;
